<script>
import Layout from '@layouts/main.vue';
import { organizationComputed } from '@state/helpers';

export default {
  page: {
    title: 'Terms',
    meta: [{ name: 'description', content: 'The Terms page.' }],
  },
  computed: {
    ...organizationComputed,
  },
  components: { Layout },
};
</script>

<template>
  <Layout>
    <div class="legal-container">
      <div class="legal-wrapper">
        <h1> {{ organizationTitle }} TRAIN Terms of Use </h1>

        <p>
          Thank you for using the {{ organizationTitle }} TRAIN mobile app
          (hereinafter the “Service”). {{ organizationTitle }} TRAIN is a
          software licensing partnership between {{ organizationTitle }} and
          Menud Co. (and its wholly owned subsidiary Plankk Technologies Inc.)
          By using {{ organizationTitle }} TRAIN you have understood and
          accepted the Terms of Use contained herein.
        </p>

        <h2>
          Fitness Disclaimer
        </h2>

        <p>
          The Content contained in the {{ organizationTitle }} Train app is for
          entertainment purposes only. {{ organizationTitle }} recommends that
          you consult a physician before beginning any exercise program or diet.
          {{ organizationTitle }}, or the personal trainers utilizing the
          {{ organizationTitle }}
          platform, are not licensed medical care providers. You should
          understand that participating in any exercise program or diet can
          result in physical injury, and you agree to do so at your own risk.
        </p>

        <h2>
          Content Disclaimer
        </h2>

        <p>
          The information presented or contained in
          {{ organizationTitle }} TRAIN, or provided through the Service
          (collectively, the “Content”) is presented for the purpose of
          educating individuals, athletes and coaches on fitness and general
          health. Nothing contained in {{ organizationTitle }} TRAIN or the
          Content is intended to be instructional for medical diagnosis or
          treatment. The information should not be considered complete, nor
          should it be relied on to suggest a course of treatment for a
          particular individual. It should not be used in place of a visit,
          call, consultation or the advice of your physician or other qualified
          healthcare provider. Information obtained from
          {{ organizationTitle }} TRAIN is not exhaustive and does not cover
          diseases, ailments, physical conditions or their treatment. Should you
          have any health care related questions, please call or see your
          physician or other qualified healthcare provider promptly. Always
          consult with your physician or other qualified healthcare provider
          before embarking on a new treatment, diet or fitness program. You
          should never disregard medical advice or delay in seeking it because
          of something you have read on {{ organizationTitle }} TRAIN. In the
          event that you find conflicting information on
          {{ organizationTitle }} TRAIN, defer to the direction of your medical
          professionals as Content contained at {{ organizationTitle }} TRAIN is
          for informational use only.
        </p>

        <p>
          The Content and other information contained in
          {{ organizationTitle }} TRAIN is compiled from a variety of sources
          and personal trainers (“Information Providers”). Neither
          {{ organizationTitle }} TRAIN nor any Information Providers directly
          or indirectly practice medicine or dispense medical services as part
          of {{ organizationTitle }} TRAIN.{{ organizationTitle }} TRAIN is not
          a substitution for the services of a physician, a health provider, or
          any trained health professional. Our policy does not allow medical
          advice, emotional advice, dietary advice, or personal advice of any
          kind. These concerns should be addressed and discussed with your
          physician, health care provider, family nutritionist or your
          registered dietitian.
        </p>

        <p>
          Adults should not commence any short or long-termed diet program
          without seeking competent medical advice.
        </p>

        <p>
          Infants, toddlers and teenagers should only participate in a diet
          program under competent medical supervision.
        </p>

        <p>
          You acknowledge that {{ organizationTitle }} TRAIN is not engaged in
          the practice of medicine and that all decisions made will be the
          exclusive responsibility of you and your physician.
        </p>

        <p>
          {{ organizationTitle }} TRAIN expressly disclaims any responsibility
          or liability for any adverse consequences or damages resulting from
          your reliance on Content contained in {{ organizationTitle }} TRAIN,
          the content or any information provided therefrom.
        </p>

        <h2>
          Additional Terms of Use
        </h2>

        <ol>
          <li
            >The findings and opinions of authors and personal trainers
            expressed herein are those of the author and do not necessarily
            state or reflect those of {{ organizationTitle }}.</li
          >
          <li
            >You are fully responsible for the information and any activity that
            occurs under your user account.</li
          >
          <li
            >You are required to use the {{ organizationTitle }} TRAIN app
            complying with {{ organizationTitle }} TRAIN’s
            <a href="/privacy">Privacy Policy.</a></li
          >
          <li
            >You are fully responsible for protecting the password that you use
            to access {{ organizationTitle }} TRAIN and for any activities made
            using your password.</li
          >
          <li
            >You must not abuse, harass, threaten, impersonate or intimidate
            other {{ organizationTitle }} TRAIN users.</li
          >
          <li
            >You may not use {{ organizationTitle }} TRAIN for any illegal or
            unauthorized purpose.</li
          >
          <li
            >International users agree to comply with all local laws regarding
            online conduct and acceptable content.</li
          >
          <li
            >You are solely responsible for your conduct and any data,
            information, names, photos, profile information, links that you
            submit, post and display on {{ organizationTitle }} TRAIN.</li
          >
          <li
            >You must not copy, create a derivative work of, nor modify another
            app to falsely imply that it is associated with
            {{ organizationTitle }} TRAIN or any of the
            {{ organizationTitle }} TRAIN products or services.</li
          >
          <li
            >You must not interfere with or disrupt
            {{ organizationTitle }} TRAIN servers or networks such as the
            transmission of worms, viruses, or any code of a destructive nature
          </li>
          <li
            >You must not violate any applicable local, state, national, or
            international law.</li
          >
          <li
            >You must not, in using {{ organizationTitle }} TRAIN, intentionally
            or unintentionally violate any application local, state, national,
            or international law.</li
          >
        </ol>

        <p>
          Violation of any of these agreements will result in the termination of
          your The {{ organizationTitle }} TRAIN account.
        </p>

        <h2>
          General Conditions
        </h2>

        <ol>
          <li
            >We reserve the right to modify or terminate the
            {{ organizationTitle }} TRAIN service for any reason, without notice
            at any time.</li
          >
          <li
            >{{ organizationTitle }} TRAIN reserves the right to change or
            modify these Terms of Use at any time. Your continued use of
            {{ organizationTitle }} TRAIN will constitute your acceptance of
            such changes or modifications, what constitutes a “material change”
            will be determined at our sole discretion, in good faith and using
            common sense and reasonable judgment.</li
          >
          <li
            >We reserve the right to refuse service to anyone for any reasonable
            judgment.</li
          >
          <li
            >We may, but have no obligations to, remove content and accounts
            containing Content that we determine in our sole discretion are
            unlawful, offensive, threatening, libelous, defamatory, obscene or
            otherwise objectionable or violates any party’s intellectual
            property or these Terms of Use.</li
          >
          <li
            >As a condition of your use of {{ organizationTitle }} TRAIN, you
            agree that {{ organizationTitle }} TRAIN has the right, for any
            purpose, to retain, use and publish data collected from your user
            account, including images uploaded to your
            {{ organizationTitle }} TRAIN user account.</li
          >
        </ol>

        <h2>
          Purchases, Subscriptions, and Cancellation
        </h2>

        <ol>
          <li
            >Subscription membership or other in app purchases are made through
            Apple’s IAP (in app purchase) function or Google’s Google Play Store
            (in app purchase) and if you wish to terminate your subscription,
            you are required to do so via Apple’s or Google’s subscription
            platform.</li
          >
          <li
            >All purchases are final and no refund will be given for unused
            portions of your initial or any renewal membership period.</li
          >
        </ol>

        <h2>
          Indemnity
        </h2>

        <ol>
          <li
            >You agree to indemnify {{ organizationTitle }} TRAIN and Menud Co.
            and Plankk Technologies Inc. on a full indemnity basis from any and
            all third party claims, liabilities, expenses including solicitor
            and client costs, that may be incurred or suffered as a result of a
            breach to any of these conditions set out in this Terms of Use by
            you or any third party damage caused as a result.</li
          >
          <li
            >You agree to indemnify {{ organizationTitle }} TRAIN, Menud Co. and
            Plankk Technologies Inc. from any liability, claim, harm, or expense
            arising from an injury or health problem that may arise from the use
            of {{ organizationTitle }} TRAIN.</li
          >
        </ol>

        <h2>
          Copyright
        </h2>

        <p>
          All the resources including the images, videos, audios and texts are
          protected by trademark and copyright. Any use of the above sources
          without permission is illegal. All right, title, and interest in and
          to {{ organizationTitle }} TRAIN are and will remain the exclusive
          property of {{ organizationTitle }} TRAIN and its licensors. Nothing
          in the Terms of Use gives you a right to use the
          {{ organizationTitle }} TRAIN name or any of the
          {{ organizationTitle }} TRAIN trademarks, logos, domain names, images,
          videos, audios and texts and other distinctive brand features.
        </p>
      </div>
    </div>
  </Layout>
</template>

<style lang="scss" scoped>
@import '@design';

.legal-container {
  background-color: $color-off-white;
}

.legal-wrapper {
  background-color: $color-white !important;
  box-shadow: 0 0 16px 0 rgba($color-black-wo-rgb, 0.25);
  margin: 0 auto;
  max-width: 600px;
  padding: 40px;
  padding-bottom: 120px;
  position: relative;
  top: 120px;
  p,
  li,
  a {
    font-size: 1.7rem;
    font-weight: 600;
    letter-spacing: unset;
    line-height: 1.2;
  }
  p {
    margin-bottom: 2rem;
  }
  li {
    margin-bottom: 1rem;
  }
}

@media screen and (max-width: 768px) {
  // stylelint-disable selector-pseudo-element-no-unknown
  ::v-deep .navbar-wrapper {
    display: none;
  }
  .legal-wrapper {
    max-width: unset;
    top: 0;
    width: 100%;
  }
}
</style>
